import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import fieldIcon from '@iconify/icons-mdi/focus-field';
import cropIcon from '@iconify/icons-mdi/sprout-outline';

@Component({
  selector: 'app-field-editor-map-view-selector',
  templateUrl: './field-editor-map-view-selector.component.html',
  styleUrls: ['./field-editor-map-view-selector.component.scss']
})
export class FieldEditorMapViewSelectorComponent implements OnInit {

  @Input()
  viewMode = 'field';

  @Output()
  viewModeChange = new EventEmitter<string>();

  viewModes = [
    {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${fieldIcon.body}</svg>`,
      text: 'Parcelle',
      mode: 'field',
      hint: 'Afficher les Parcelles'
    },
    {
      icon: `<svg  width="18px" height="18px" viewBox="0 0 24 24">${cropIcon.body}</svg>`,
      text: 'Culture',
      mode: 'crop',
      hint: 'Afficher les Cultures'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

  itemClick(e) {
    this.viewModeChange.emit(e.itemData.mode);
  }
}
